import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(3),
  },
}));

export default function RadioButtonsGroup(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState('female');

  const handleChange = event => {
    props.setDynamicGraph(event.target.value);
    setValue(event.target.value);
  };

  return (
    <div style={{width: "100%", height: "auto", marginBottom: '3%', display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap'}}>
      <FormControl component="fieldset" style={{width: "30%", margin:'1% 0'}}>
        <RadioGroup aria-label="gender" name="gender1" value={value} onChange={handleChange} style={{width: "auto ", display: 'flex', flexDirection: 'row', justifyContent: 'center', border: '1px solid black', backgroundColor: props.color ? props.color : "#E14E81", color: 'white', fontWeight: 'bolder', borderRadius:'6px'}}>
          <FormControlLabel value="edad_ingreso" control={<Radio />} label="Edad" />
          <FormControlLabel value="edad_ingreso" control={<Radio color="primary" />} label="Ingreso" />
        </RadioGroup>
      </FormControl>
      <FormControl component="fieldset" style={{width: "30%", margin:'1% 0'}}>
        <RadioGroup aria-label="gender" name="gender1" value={value} onChange={handleChange} style={{width: "auto ", display: 'flex', flexDirection: 'row',  justifyContent: 'center', border: '1px solid black', backgroundColor: props.color ? props.color : "#E14E81", color: 'white', fontWeight: 'bolder', borderRadius:'6px'}}>
          <FormControlLabel value="edad_region" control={<Radio />} label="Edad" />
          <FormControlLabel value="edad_region" control={<Radio color="primary" />} label="Región" />
        </RadioGroup>
      </FormControl>
      <FormControl component="fieldset" style={{width: "30%", margin:'1% 0'}}>
        <RadioGroup aria-label="gender" name="gender2" value={value} onChange={handleChange} style={{width: "auto ", display: 'flex', flexDirection: 'row', justifyContent: 'center', border: '1px solid black', backgroundColor: props.color ? props.color : "#E14E81", color: 'white', fontWeight: 'bolder', borderRadius:'6px'}}>
          <FormControlLabel value="region_ingreso" control={<Radio />} label="Región" />
          <FormControlLabel value="region_ingreso" control={<Radio color="primary" />} label="Ingreso" />
        </RadioGroup>
      </FormControl>
      <FormControl component="fieldset" style={{width: "30%", margin:'1% 0'}}>
        <RadioGroup aria-label="gender" name="gender1" value={value} onChange={handleChange} style={{width: "auto ", display: 'flex', flexDirection: 'row', justifyContent: 'center', border: '1px solid black', backgroundColor: props.color ? props.color : "#E14E81", color: 'white', fontWeight: 'bolder', borderRadius:'6px'}}>
          <FormControlLabel value="sexo_edad" control={<Radio />} label="Sexo" />
          <FormControlLabel value="sexo_edad" control={<Radio color="primary" />} label="Edad" />
        </RadioGroup>
      </FormControl>
      <FormControl component="fieldset" style={{width: "30%", margin:'1% 0'}}>
        <RadioGroup aria-label="gender" name="gender1" value={value} onChange={handleChange} style={{width: "auto ", display: 'flex', flexDirection: 'row',  justifyContent: 'center', border: '1px solid black', backgroundColor: props.color ? props.color : "#E14E81", color: 'white', fontWeight: 'bolder', borderRadius:'6px'}}>
          <FormControlLabel value="sexo_ingreso" control={<Radio />} label="Sexo" />
          <FormControlLabel value="sexo_ingreso" control={<Radio color="primary" />} label="Ingreso" />
        </RadioGroup>
      </FormControl>
      <FormControl component="fieldset" style={{width: "30%", margin:'1% 0'}}>
        <RadioGroup aria-label="gender" name="gender2" value={value} onChange={handleChange} style={{width: "auto ", display: 'flex', flexDirection: 'row', justifyContent: 'center', border: '1px solid black', backgroundColor: props.color ? props.color : "#E14E81", color: 'white', fontWeight: 'bolder', borderRadius:'6px'}}>
          <FormControlLabel value="sexo_region" control={<Radio />} label="Sexo" />
          <FormControlLabel value="sexo_region" control={<Radio color="primary" />} label="Región" />
        </RadioGroup>
      </FormControl>
    </div>
  );
}